// Format, and deliberately nothing else. A misspelled domain («gmial.com») is a well-formed address
// and this function says so: judging deliverability here would block the very correction CC is
// called to make. The server validates again on its own terms — this is the check that keeps the
// agent from spending a round trip on a typo the field can see.
//
// One `@`, something either side, and a dot inside the domain. Not RFC 5322: that grammar accepts
// quoted locals and bracketed literals nobody types into this field, and a regex for it is a
// liability rather than a guarantee.
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmailFormat(value: string): boolean {
  return EMAIL_SHAPE.test(value.trim());
}
